export const getVacancyLoadAccessErrorMessage = (status: number | null): string | null => {
  if (status === 403) {
    return 'Нет доступа к вакансии';
  }

  if (status === 404) {
    return 'Вакансия не найдена';
  }

  return null;
};
